module.exports = __webpack_public_path__ + "img/三门控制器 (1).ac06cd6e.jpg";